import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-slo",
  "use": "app-icon-slo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-slo\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#666\" d=\"M6.54 7.849L4.324 6.19l2.767-.073.892-2.621.925 2.61 2.768.038L9.48 7.83l.819 2.645-2.282-1.566-2.262 1.594z\" /><path d=\"M14 7A6 6 0 012 7a6 6 0 0112 0z\" stroke=\"#666\" stroke-width=\"2\" /><path fill=\"#666\" d=\"M4 12v4l4-1.833L12 16v-4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol